import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            {aboutData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutData.content}
          </p>
        </div>
      </div>
    </section>
  );
}